import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export type DownloadTypes =
  | 'diagnosis'
  | 'infestation'
  | 'infestation_pdf'
  | 'infestation_csv'
  | 'infestation_splitted'
  | 'infestation_splitted_pdf'
  | 'mosaic'
  | 'planting_failure'
  | 'perimeter'
  | 'thumbnail'
  | 'pulverization'
  | 'pulverization_splitted'
  | 'pulverization_pdf'
  | 'pulverization_splitted_pdf'
  | 'pulverization_spreadsheet'
  | 'mosaic_cog'
  | 'planting_failure_splitted'

export async function getURLToDownloadFile(
  culture: string,
  demandId: string,
  type: DownloadTypes,
) {
  const {
    data: { url },
  } = await companiesApi.get<{ url: string }>(
    apiRoutes.getURLToDownloadFile(culture, demandId, type),
  )

  return url
}
